import script from "./EditOrganizationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditOrganizationView.vue?vue&type=script&setup=true&lang=ts"

import "./EditOrganizationView.vue?vue&type=style&index=0&id=652e63e2&lang=scss"

const __exports__ = script;

export default __exports__